const Newsletter = () => {
    return (
      <div className="newsletter-area section-bg ptb-100">
      <div className="container">
          <div className="row">
              <div className="col-lg-5">
                  <div className="section-title mt-rs-20">
                      <span>ARE YOU IMPRESSED FOR AMAZING SERVICES?</span>
                      <h2>Subscribe our newsletter</h2>
                  </div>
              </div>
              <div className="col-lg-7">
                  <form className="newsletter-form" data-toggle="validator" method="POST">
                      <input type="email" className="form-control" placeholder="Enter Your Email Address" name="EMAIL" required autoComplete="off"/>
                      <button className="subscribe-btn" type="submit">
                          Subscribe Now  <i className="flaticon-paper-plane"></i>
                      </button>
                      <div id="validator-newsletter" className="form-result"></div>
                  </form>
              </div>
          </div>
      </div>
</div>
    );
  }
  
  export default Newsletter;  